import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import pageTemplate from "text!../../../templates/mylibrary/myLibrary2PageTemplate.html";
import LibraryPage from "../../components/library/LibraryPage";
import ti18n from "i18n!nls/MyLibraryi18n";

const MyLibrary2PageView = Backbone.View.extend({
  template: _.template(pageTemplate),

  pageName: "My Library 2",

  events: {
    "click #homeHeaderButton": "onHomeButtonSelected",
    "click #createContentButton": "onCreateContent",
  },

  initialize: function (options) {
    this._reactRoot = null;
  },

  onHomeButtonSelected: function () {
    this.trigger("showHomePopup");
  },

  onCreateContent: function () {
    // React-owns-the-trigger bridge: LibraryPage listens on this event so it
    // can pass the active folder id into the Create Content flow. Falls back
    // to the Backbone trigger below for any non-React consumer still wired to
    // the old path.
    try {
      window.dispatchEvent(new CustomEvent("trebble:create-content-requested"));
    } catch (e) {
      // CustomEvent unsupported in ancient browsers — ignore and fall through.
    }
    this.trigger("createCapsule");
  },

  _onPageShow: function () {
    this.trigger("pageshow");
  },

  _onPageHide: function () {
    try {
      window.dispatchEvent(new Event("trebble:library-stop-inline-playback"));
    } catch (e) {
      // No-op: this event only stops inline card previews.
    }
    this.trigger("pagehide");
  },

  _onPageRemoved: function () {
    if (this._reactRoot) {
      this._reactRoot.unmount();
      this._reactRoot = null;
    }
    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.stopListening();
  },

  _renderLibraryPage: function () {
    var reactContainer = this.$el.find("#libraryReactRoot").get(0);
    if (!reactContainer) return;

    if (!this._reactRoot) {
      this._reactRoot = createRoot(reactContainer);
    }

    this._reactRoot.render(
      React.createElement(LibraryPage, {
        section: "library",
      })
    );
  },

  render: function () {
    this.$el.html(this.template({ ti18n: ti18n }));
    this.setElement(this.$el.find("div").first());
    this.$el.page();

    // Mount React component
    this._renderLibraryPage();

    // Manually wrap for JQM panel support
    this.$el
      .children(
        ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)"
      )
      .wrapAll("<div class='ui-panel-wrapper'></div>");

    this.$el.on("pageshow", this._onPageShow.bind(this));
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("remove", this._onPageRemoved.bind(this));

    return this;
  },
});

export default MyLibrary2PageView;
